import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "panel" }

import { ref } from 'vue';
import { useGettext } from '@jshmrtn/vue3-gettext';
import { getValueInUserLanguage } from '@/core/languageContent';
import PageLayout from '@/core/components/PageLayout.vue';
import ResourceTable from '@/core/components/resource/ResourceTable.vue';
import Column from '@/core/components/resource/Column';
import ActionColumn from '@/core/components/resource/ActionColumn';
import { Product, typeNames, useProduct } from '@/modules/product/Product';
import { formatCurrency } from '@/core/number';
import { dateTime } from '@/core/date';


export default /*@__PURE__*/_defineComponent({
  __name: 'ProductIndex',
  setup(__props) {

const { $gettext } = useGettext();
const resource = useProduct();
const productToDelete = ref<Product>();
const deleteName = () => {
	if (!productToDelete.value) {
		return '';
	}

	return getValueInUserLanguage(productToDelete.value?.content);
};

const columns = [
	new Column<Product>($gettext('Namn'), 'content', 'name', '+')
		.withFormatter(row => getValueInUserLanguage(row.content) as string),
	new Column<Product>($gettext('Pris'), 'price', 'price')
		.withFormatter(row => formatCurrency(row.price)),
	new Column<Product>($gettext('Produkttyp'), 'type', 'type')
		.withFormatter(row => typeNames[row.type]),
	new Column<Product>($gettext('Skapad'), 'created_time', 'created_time')
		.withFormatter(row => dateTime(row.created_time)),
	new ActionColumn<Product>()
		.withEditLink((p) => ({ name: 'product.edit', params: { id: p.id } }))
		.withDeleteLink((p: Product) => {
			productToDelete.value = p;
		}),
];

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _directive_translate = _resolveDirective("translate")!

  return (_openBlock(), _createBlock(PageLayout, {
    "page-title": _unref($gettext)('Produkter')
  }, {
    "header-actions": _withCtx(() => [
      _withDirectives((_openBlock(), _createBlock(_component_RouterLink, {
        to: {
				name: 'product.create',
				params: {type: 'subscription'},
			},
        class: "button"
      }, {
        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
          _createTextVNode(" Nytt abonnemang ", -1)
        ]))]),
        _: 1
      })), [
        [_directive_translate]
      ]),
      _withDirectives((_openBlock(), _createBlock(_component_RouterLink, {
        to: {
				name: 'product.create',
				params: {type: 'addon'},
			},
        class: "button"
      }, {
        default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
          _createTextVNode(" Nytt tillägg ", -1)
        ]))]),
        _: 1
      })), [
        [_directive_translate]
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(ResourceTable, {
          resource: _unref(resource),
          columns: columns,
          "delete-title": _unref($gettext)('Ta bort produkt'),
          "delete-name-key": deleteName,
          "to-delete": productToDelete.value,
          "onUpdate:toDelete": _cache[0] || (_cache[0] = ($event: any) => ((productToDelete).value = $event))
        }, null, 8, ["resource", "delete-title", "to-delete"])
      ])
    ]),
    _: 1
  }, 8, ["page-title"]))
}
}

})